/**
 * Human-readable label for header/sidebar (DB profile, then OAuth metadata, then email).
 */
export function getProfileDisplayName(user, dbUser, fallback = 'there') {
  const fromDb = (dbUser?.name || '').trim();
  if (fromDb) return fromDb;
  const uname = (dbUser?.username || '').trim();
  if (uname) return uname;
  const meta = user?.user_metadata || {};
  const combined = [meta.given_name, meta.family_name].filter(Boolean).join(' ').trim();
  const fromOAuth = (meta.full_name || meta.name || combined || '').trim();
  if (fromOAuth) return fromOAuth;
  const email = user?.email;
  if (email && typeof email === 'string') {
    const local = email.split('@')[0];
    if (local) return local;
  }
  return fallback;
}
